import EventBus from '@/helpers/event-bus'
const lib = 'google'
export const EVENTS = {
  READY: lib + '.ready',
  WAITING: lib + '.waiting',
  SUCCESS: lib + '.success',
  FAILED: lib + '.failed',
  LOGIN: lib + '.login',
  LOGOUT: lib + '.logout'
}

export default (function () {
  var config = null
  var id = 'googlejs-sdk'
  var apiUrl = '//apis.google.com/js/api:client.js'
  var auth2 = null

  function Auth () {
    return {
      init: (api) => {
        config = {
          client_id: api,
          scope: 'profile email https://www.googleapis.com/auth/plus.login'
        }

        return new Promise(function (resolve, reject) {
          try {
            /* eslint-disable */
            if (IN === undefined) {
              loadJS().then(function () {
                return initClient()
              }).then(function () {
                resolve()
              })
            /* eslint-disable */
            } else if (IN !== undefined && IN.init === undefined) {
              initClient().then(function () {
                resolve()
              })
            }
          } catch (e) {
            loadJS().then(function () {
              console.log('Load ', lib)
              return initClient()
            }).then(function () {
              resolve()
            })
          }
        })
      },
      singIn: () => {
        try {
          /* eslint-disable */
          window.gapi.auth2.getAuthInstance().signIn().then(function (googleUser) {
            EventBus.$emit(EVENTS.SUCCESS, googleUser.getBasicProfile())
          }, function (error) {
            EventBus.$emit(EVENTS.FAILED, error)
          })
        } catch (e) {
          console.log('Not ready yet ', lib, e)
          EventBus.$emit(EVENTS.FAILED, 'Aún estamos cargando, por favor espere...')
        }
      },
      singOut: () => {
        try {
          /* eslint-disable */
          window.gapi.auth2.getAuthInstance().signOut().then(function () {
            EventBus.$emit(EVENTS.LOGOUT)
          }, function (error) {
            EventBus.$emit(EVENTS.FAILED, error)
          })
        } catch (e) {
          console.log('Not ready', e)
          EventBus.$emit(EVENTS.FAILED, 'Aún estamos cargando, por favor espere...')
        }
      }
    }
  }

  function loadJS () {
    return new Promise(function (resolve, reject) {
      var head = document.getElementsByTagName('head')[0]
      if (document.getElementById(id)) return
      var script = document.createElement('script'); script.id = id
      script.async = false
      script.src = apiUrl
      script.onload = function () {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          setTimeout(function () {
            resolve()
          }, 500)
        }
      }
      head.appendChild(script)
    })
  }

  function initClient () {
    return new Promise(function (resolve, reject) {
      /* eslint-disable */
      window.gapi.load('auth2', function () {
        auth2 = window.gapi.auth2.init(config)
        auth2.isSignedIn.listen(checkStatus)
      })
      EventBus.$emit(EVENTS.READY)
      console.log('Ready ', lib)
      resolve()
    })
  }

  function checkStatus() {
    EventBus.$emit(EVENTS.LOGIN)
    /* eslint-disable */
    if (auth2.isSignedIn.get()) {
      var data = auth2.currentUser.get().getBasicProfile()
      EventBus.$emit(EVENTS.SUCCESS, data)
    }
  }

  return Auth
})()



// WEBPACK FOOTER //
// ./src/helpers/google.js